<template>
  <div>
    <a>
      <img v-bind:src="photo.zoom" @click="show" :title="photo.filename"/>
      <div class="caption caption-top">
        <div class="top-tools">
          <a class="download-free" @click="download" v-if="free || adminDownload" :title="$t('photo.download')">
            <i class="fa fa-arrow-down"></i>
          </a>
          <a class="share-social-media" @click="share" v-if="free && socialShare" :title="$t('photo.share')">
            <i class="fa fa-share-alt"></i>
          </a>
          <a v-if="isActiveAlbum && image.in_album" class="btn-photo-album" @click="removeFromAlbum"
             :title="$t('photo.removeFromAlbum')"
             v-bind:style="displayInAlbum">
            <i class="fa fa-check active"></i>
          </a>
          <a v-if="isActiveAlbum && !image.in_album" class="btn-photo-album" @click="addToAlbum"
             :title="$t('photo.addToAlbum')"
             v-bind:style="displayInAlbum">
            <i class="fa fa-check"></i>
          </a>
        </div>
      </div>
      <div class="caption caption-bottom">
        <ul class="tools">
          <li v-if="isAdminOrManager && !photo.visible">
            <a class="cart hide-photo-btn" :title="$t('photo.show')" @click="changeVisible()">
              <i class="fas fa-eye-slash"></i>
            </a>
          </li>
          <li v-if="isAdminOrManager && photo.visible">
            <a class="cart show-photo-btn" :title="$t('photo.hide')" @click="changeVisible()">
              <i class="fas fa-eye"></i>
            </a>
          </li>
          <li v-if="photo.selected">
            <a class="favorite" :title="$t('photo.removeFromFavorites')" @click="remove" v-bind:style="display">
              <i class="fa fa-heart"></i>
            </a>
          </li>
          <li v-if="!photo.selected">
            <a class="favorite" :title="$t('photo.addToFavorites')" @click="add">
              <i class="fa fa-heart-o"></i>
            </a>
          </li>
          <li v-if='photo.search_face'>
            <a class="favorite" :title="$t('photo.rekognition')" @click="rekognition">
              <img src="/rekognition.png">
            </a>
          </li>
          <li v-if="!free">
            <a class="cart" :title="$t('photo.addToCart')" @click="addToCart">
              <i class="fa fa-shopping-cart"></i>
            </a>
          </li>

        </ul>
      </div>
      <SocialMedia
          :activeShareMedia="activeShare"
          :photo="photo"
          @closeSocialMedia="closeSocialMedia"/>
    </a>
  </div>
</template>

<script>
import $ from 'jquery';
import Photo from '../models/Photo';
import { mapGetters, mapActions } from 'vuex';
import AdminPhotoApi from '../api/AdminPhotoApi';
import DownloadMixin from '../mixins/DownloadMixin';
import SocialMedia from '../components/SocialMedia';

export default {
  mixins: [
    DownloadMixin
  ],
  components: {
    SocialMedia
  },
  props: {
    photo: {
      type: Object,
      default: null
    },
    event: {
      type: Object,
      default: null
    },
    competitor: {
      type: Object,
      default: null
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    albumId: {
      type: String,
      default: null
    },
    hasRekognition: {
      type: Boolean,
      default: true
    },
    isActiveAlbum: {
      type: Boolean,
      default: false
    },
    textImage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      image: {},
      activeShare: false,
      currentPhoto: new Photo()
    };
  },
  mounted() {
    this.image = this.photo
    this.currentPhoto = new Photo(this.photo)
  },
  methods: {
    ...mapActions('ShoppingCartStore', ['addShoppingCartItem']),
    
    async add() {
      this.image.selected = true
      this.currentPhoto.addFavorite(this.parameters).then(() => {
        this.$root.$emit('addFavoritePhoto', this.image)
      }).catch((error) => {
        this.image.selected = false
        const errors = error.response.response.data.errors;
        if (errors["user_id"].length > 0) {
          this.$alertify.error(this.$t("auth.requiredLogin"))
          this.$root.$emit("openSignIn")
        }
      })
    },
    async remove() {
      this.image.selected = false
      this.currentPhoto.selected = false
      this.$root.$emit('removeFavoritePhoto', this.currentPhoto)

      this.currentPhoto.removeFavorite(this.parameters).then(() => {
      })
          .catch((error) => {
            console.log(error)
          })
    },
    async download() {
      if (this.requireSignIn) {
        this.openSignin();
      } else {
        await this.downloadPhoto(this.currentPhoto);
      }
    },
    async rekognition() {
      let competitor = null
      this.$emit("setLoader", true)

      if (this.competitor && this.competitor.number) {
        competitor = this.competitor.number
      }

      const params = {
        event_id: this.eventId.toString(),
        photo_id: this.image.id,
        competitor: competitor
      }

      this.currentPhoto.rekognition(params).then((object) => {
        this.$root.$emit('addRekognitionPhotos', object.response.data.photos)
        this.$emit("setLoader", false)
      }).catch((error) => {
        console.log(error)
        this.$emit("setLoader", false)
      })
    },
    async addToCart() {
      const params = { event_id: this.eventId, photo_id: this.image.id };
      this.$alertify.success(this.$t("checkout.addedItem"));
      await this.addShoppingCartItem(params);
      this.$root.$emit("addItemToCart", params);
    },
    async changeVisible() {
      const visible = !this.image.visible;

      const response = await AdminPhotoApi.update(this.image.id, {
        photo: {
          visible: visible
        }
      });

      if(response) {
        this.image.visible = visible;
        this.$alertify.success(visible ? this.$t("photo.showMessage") : this.$t("photo.hideMessage"));
      }
    },
    async addToAlbum() {
      this.image.in_album = true;
      await this.currentPhoto.addToAlbum(this.albumId);
      this.$root.$emit('addPhotoToAlbum', this.image);
    },
    async removeFromAlbum() {
      this.image.in_album = false;
      await this.currentPhoto.removeFromAlbum(this.albumId);
      this.$root.$emit('removePhotoFromAlbum', this.image);
    },
    share() {
      if (this.requireSignIn) {
        this.openSignin();
      } else {
        this.activeShare = true;
      }
    },
    show() {
      this.$root.$emit('openZoom', this.photo);
    },
    findImage() {
      var _this = this, image = {}, index = 0;
      $(this.photos).each(function (i, el) {
        if (el.id == _this.photo.id) {
          index = i;
          image = el;
        }
      });
      return {index: index, image: image};
    },
    closeSocialMedia() {
      this.activeShare = false;
    }
  }
  ,
  computed: {
    ...mapGetters('Auth', ['currentUser']),

    parameters() {
      return {
        photo_id: this.image.id,
        competitor: this.competitorId
      };
    },
    eventId() {
      return this.event.identifier;
    },
    competitorId() {
      return (this.competitor == null) ? null : this.competitor.number;
    },
    free() {
      return this.image.sponsored;
    },
    socialShare() {
      return this.event.share_social_media;
    },
    display() {
      var visible = this.photo.selected ? 'block !important' : 'none';
      return { display: visible };
    },
    displayInAlbum() {
      const visible = this.photo.in_album ? 'block !important' : 'none';
      return {display: visible};
    },
    adminDownload() {
      return this.currentUser.downloadFullResolution();
    },
    isAdminOrManager() { 
      return this.currentUser.hasAdminOrManagerAccess();
    }
  }
}
</script>
<style lang="scss" scoped>
.hide-photo-btn {
  background: #ff0000 !important;
}

.hide-photo-btn i {
  color: white;
}

.show-photo-btn {
  background: green !important;
}

.show-photo-btn i {
  color: white;
}


</style>